module.exports = __webpack_public_path__ + "img/platform_mj1.945f7628.png";